// NOTE: fallback for Safari, which does not have screen.orientation object
// https://developer.mozilla.org/en-US/docs/Web/API/Screen/orientation
export function getOrientationTypeBasedOnScreenSize(): OrientationType {
    return screen.availHeight > screen.availWidth
        ? 'portrait-primary'
        : 'landscape-primary'
}
